import { atom } from "jotai";
import { Refresh } from "../types/refresh";

export const refreshAtomUsers = atom<Refresh | null>(null);
